// extracted by mini-css-extract-plugin
export default {"container":"Intro_container__K8OXp","innerContainer":"Intro_innerContainer__EfXBU","logo":"Intro_logo__yqazt","intro":"Intro_intro__RtVCq"};